var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-section',{attrs:{"title":_vm.$t('Automations_Title_Schedule'),"description":_vm.$t('Automations_Title_Schedule_Description')}},[_c('recurrence-settings',{attrs:{"model":_vm.model.schedule,"timezone":_vm.$store.state.app.project.timezone,"disabled":_vm.readonly,"delta":_vm.model.config.delta}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd9577ac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/automations/components/StepExportExecutionSchedule.vue
// module id = null
// module chunks = 